import React, { useState, useEffect } from 'react';
import '../App.css';

const faqs = [
  {
    question: "1. What is the Outstanding Workplaces Certification?",
    answer: (
        <>
        <span>
            It is a recognition awarded to organizations that demonstrate excellence in employee experience, culture, leadership practices, inclusion, well-being, and sustainability. The certification is based on a balanced assessment of employee surveys and organizational practices.
        </span>
        </>
    )
  },
  {
    question: "2. Why should organizations go for this certification?",
    answer: (
        <>
        <span>
            Certification boosts employer branding, talent attraction, retention, customer trust, and industry recognition. It also provides data-driven insights for continuous improvement in workplace culture and leadership.
        </span>
        </>
    )
  },
   {
        question: "3. How is the assessment conducted?",
        answer: (
        <>
            <div>The assessment has two parts:</div>
            <ul style={{ marginTop: 0, marginBottom: 0, paddingLeft: 24 }}>
            <li>
                Employee Survey (70%) – anonymous survey measuring engagement, trust, well-being, inclusion, and workplace satisfaction.
            </li>
            <li>
                Practices Audit (30%) – review of HR, leadership, policies, ESG/CSR, and innovation practices.
            </li>
            </ul>
        </>
        )
    },
   {
        question: "4. How many employees are required to participate in the survey?",
        answer: (
        <>
            <ul style={{ marginTop: 0, marginBottom: 0, paddingLeft: 24 }}>
                <li>
                    Small companies (10–99 employees): All employees are surveyed.
                </li>
                <li>
                    Medium & Large (100+ employees): A statistically valid sample (minimum 70%) must participate.
                </li>
            </ul>
        </>
        )
    },
      {
        question: "5. How long does the certification process take?",
        answer: (
            <>
            <span>
                Typically, 2–3 weeks from survey launch to certification result, depending on the company’s size and data submission speed.
            </span>
            </>
        )
    },
  {
        question: "6. What are the rating levels?",
        answer: (
        <>
            <div>Organizations are certified under four categories:</div>
            <ul style={{ marginTop: 0, marginBottom: 0, paddingLeft: 24 }}>
                <li>
                    Platinum Outstanding Workplaces (90–100%)
                </li>
                <li>
                    Gold Outstanding Workplaces (80–89%)
                </li>
                <li>
                    Certified Outstanding Workplaces (70–79%)
                </li>
            </ul>
        </>
        )
    },
    {
        question: "7. How long is the certification valid?",
        answer: (
            <>
            <span>
                The certification is valid for 1 year. Organizations are required to renew annually to maintain status and track cultural improvements.
            </span>
            </>
        )
    },
    {
        question: "8. Is this certification only for large organizations?",
        answer: (
            <>
            <span>
                No. The framework is designed to fairly assess organizations of all sizes – from SMEs to large enterprises – with benchmarks adjusted by size and industry.
            </span>
            </>
        )
    },
    {
        question: "9. Can startups apply for the certification?",
        answer: (
            <>
            <span>
                Yes, startups with a minimum of 10 employees and 2 years of operations are eligible. A simplified assessment model is applied for them.
            </span>
            </>
        )
    },
    {
        question: "10. What industries can apply?",
        answer: (
            <>
            <span>
                Any industry – IT, manufacturing, services, education, healthcare, retail, nonprofit, etc. – can apply. Assessments are tailored by industry benchmarks.
            </span>
            </>
        )
    },
    {
        question: "11. What are the tangible benefits for talent attraction?",
        answer: (
        <>
            <div>Certified companies experience:</div>
            <ul style={{ marginTop: 0, marginBottom: 0, paddingLeft: 24 }}>
                <li>
                    2–3x higher job applications.
                </li>
                <li>
                    20–30% lower hiring costs.
                </li>
                <li>
                    Stronger employer branding on LinkedIn, job portals, and media.
                </li>
            </ul>
        </>
        )
    },
    {
        question: "12. What’s the ROI for the organization?",
        answer: (
        <>
            <div>Organizations often achieve:</div>
            <ul style={{ marginTop: 0, marginBottom: 0, paddingLeft: 24 }}>
                <li>
                    15–25% lower attrition.
                </li>
                <li>
                    10–20% higher engagement/productivity.
                </li>
                <li>
                    Higher RFP success rates and customer trust.
                </li>
                <li>
                    This translates to multi-crore annual savings and revenue growth.
                </li>
            </ul>
        </>
        )
    },
    {
        question: "13. How confidential are the survey results?",
        answer: (
            <>
            <span>
                Employee responses are 100% anonymous. Reports are presented at aggregate level only, ensuring confidentiality and trust.
            </span>
            </>
        )
    },
    {
        question: "14. What happens if an organization does not meet the certification threshold?",
        answer: (
            <>
            <span>
                If the score is below 60%, the organization will not be certified. However, they will receive a detailed improvement report and can reapply after implementing changes.
            </span>
            </>
        )
    },
    {
        question: "15. How is Outstanding Workplaces Certification different from others?",
        answer: (
        <>
            <ul style={{ marginTop: 0, marginBottom: 0, paddingLeft: 24 }}>
                <li>
                    Includes Responsible AI, ESG, and Digital Well-being as key pillars.
                </li>
                <li>
                    Provides fair benchmarking for SMEs and large firms separately.
                </li>
                <li>
                    Offers annual feedback reports to drive continuous improvement.
                </li>
                <li>
                    Focuses strongly on psychological safety and resilience, beyond engagement.
                </li>
            </ul>
        </>
        )
    },

  // Add more FAQs as needed
];


function FAQs() {
  const [openIdx, setOpenIdx] = useState(null);

  useEffect(() => {
    document.title = "FAQs | Outstanding Workplaces";
  }, []);

  return (
    <section className="faqs-section">
      <div className="faqs-container">
        <h1 className="faqs-title">
          Frequently Asked Questions
        </h1>
        <div className="faqs-list">
          {faqs.map((faq, idx) => (
            <div className="faq-item" key={idx}>
              <button
                className={`faq-question${openIdx === idx ? ' open' : ''}`}
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                aria-expanded={openIdx === idx}
                aria-controls={`faq-answer-${idx}`}
              >
                <span className="faq-q-text">{faq.question}</span>
                <span className="faq-q-icon">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={openIdx === idx ? "rotated" : ""}
                  >
                    <path
                      d="M8 12L14 18L20 12"
                      stroke="#fff"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </button>
              {openIdx === idx && (
                <div
                  className="faq-answer"
                  id={`faq-answer-${idx}`}
                >
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQs;